var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"site-scroll-top"}},[_c('span',{staticClass:"ticon",attrs:{"aria-hidden":"true"}},[_c('img',{attrs:{"src":require("../assets/img/arrow-up.png")}})]),_c('span',{staticClass:"screen-reader-text"},[_vm._v("Back To Top")])])
}]

export { render, staticRenderFns }